import { Hammer, Wrench, Home, Droplet, Zap, PaintBucket } from 'lucide-react';

export const services = [
  { name: 'Menuiserie', icon: Hammer },
  { name: 'Isolation', icon: Home },
  { name: "Installation d'eau et de gaz", icon: Droplet },
  { name: 'Meubles sur mesure', icon: Wrench },
  { name: 'Climatisation', icon: Wrench },
  { name: 'Pompe à chaleur', icon: Wrench },
  { name: 'Plomberie', icon: Droplet },
  { name: 'Chauffage', icon: Home },
  { name: 'Électricité', icon: Zap },
  { name: 'Peinture et décoration', icon: PaintBucket },
  { name: 'Parquets', icon: Hammer },
  { name: 'Maçonnerie', icon: Hammer },
];
